(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  document.querySelectorAll('.site-footer').forEach(function(ft){
    var pin = function(){ if(ft.scrollTop || ft.scrollLeft){ ft.scrollTop = 0; ft.scrollLeft = 0; } };
    ft.addEventListener('scroll', pin, {passive:true}); pin(); window.addEventListener('load', pin);
  });
  document.querySelectorAll('.site-footer [data-gated-form]').forEach(function(f){
    var id = f.id, mine = false;
    try { mine = sessionStorage.getItem('csp-gate') === id; } catch(e){}
    if(!mine && location.hash === '#' + id) mine = true;
    if(mine){
      try { sessionStorage.removeItem('csp-gate'); } catch(e){}
      var done = f.querySelector('[data-done]'), gate = f.querySelector('[data-gate]'), err = f.querySelector('[data-err]');
      if(done){ done.hidden = false; if(gate) gate.hidden = true; }
      if(err) err.hidden = false;
    }
    f.addEventListener('submit', function(){ try { sessionStorage.setItem('csp-gate', id); } catch(e){} });
  });
  document.querySelectorAll('.site-footer .fin').forEach(function(fin){
    if(!('IntersectionObserver' in window)) return;
    if(fin.querySelector('.fnews-done:not([hidden]), .form-error:not([hidden])')) return;
    Array.prototype.forEach.call(fin.children, function(c,i){ c.style.setProperty('--i', i); });
    fin.classList.add('willstagger');
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ fin.classList.add('inview'); io.disconnect(); } });
    }, {threshold:.12});
    io.observe(fin);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

(function(){
  'use strict';
  var root = document.querySelector('.css-header-section');
  if(!root) return;
  var mq = window.matchMedia('(min-width:1024px)');
  var header = root.querySelector('.site-header');
  var scrim  = root.querySelector('#scrim');
  var triggers = Array.prototype.slice.call(root.querySelectorAll('.navtrigger'));
  var open = null, hoverIn = null, hoverOut = null, hideTimer = null;

  function panelOf(t){ return root.querySelector('#' + t.getAttribute('aria-controls')); }
  function linksIn(p){ return Array.prototype.slice.call(p.querySelectorAll('a[href],button:not([disabled])')); }

  function show(t){
    if(open === t) return;
    if(open) hide(open, true);
    var p = panelOf(t);
    clearTimeout(hideTimer);
    p.hidden = false; scrim.hidden = false;
    void p.offsetWidth;
    p.classList.add('on'); scrim.classList.add('on');
    t.setAttribute('aria-expanded','true');
    open = t;
  }
  function hide(t, instant){
    if(!t) return;
    var p = panelOf(t);
    p.classList.remove('on');
    t.setAttribute('aria-expanded','false');
    if(t === open){ open = null; scrim.classList.remove('on'); }
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function(){
      if(!p.classList.contains('on')) p.hidden = true;
      if(!open) scrim.hidden = true;
    }, instant ? 0 : 200);
  }
  function hideAll(){ if(open) hide(open); }

  triggers.forEach(function(t, i){
    var p = panelOf(t);

    t.addEventListener('click', function(e){
      e.preventDefault();
      open === t ? hide(t) : show(t);
    });

    t.addEventListener('pointerenter', function(e){
      if(e.pointerType !== 'mouse' || !mq.matches) return;
      clearTimeout(hoverOut);
      hoverIn = setTimeout(function(){ show(t); }, 120);
    });
    t.addEventListener('pointerleave', function(e){
      if(e.pointerType !== 'mouse') return;
      clearTimeout(hoverIn);
      hoverOut = setTimeout(function(){ if(open === t) hide(t); }, 220);
    });
    p.addEventListener('pointerenter', function(){ clearTimeout(hoverOut); });
    p.addEventListener('pointerleave', function(e){
      if(e.pointerType !== 'mouse') return;
      hoverOut = setTimeout(function(){ if(open === t) hide(t); }, 220);
    });

    t.addEventListener('keydown', function(e){
      if(e.key === 'ArrowDown'){
        e.preventDefault(); show(t);
        var l = linksIn(p); if(l.length) setTimeout(function(){ l[0].focus(); }, 30);
      } else if(e.key === 'ArrowRight' || e.key === 'ArrowLeft'){
        e.preventDefault();
        var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + triggers.length) % triggers.length;
        triggers[n].focus();
        if(open) show(triggers[n]);
      } else if(e.key === 'Escape'){ hide(t); }
    });

    p.addEventListener('focusout', function(e){
      if(!e.relatedTarget) return;
      if(!p.contains(e.relatedTarget) && e.relatedTarget !== t) hide(t);
    });
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && open){ var t = open; hide(t); t.focus(); }
  });
  document.addEventListener('click', function(e){
    if(open && !header.contains(e.target)) hideAll();
  });
  scrim.addEventListener('click', hideAll);
  window.addEventListener('scroll', function(){ if(open) hideAll(); }, {passive:true});

  var burger = root.querySelector('#burger');
  var drawer = root.querySelector('#drawer');
  var dclose = root.querySelector('#dclose');
  var lastFocus = null;

  function focusables(){
    return Array.prototype.slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])'))
      .filter(function(el){ return el.offsetParent !== null; });
  }
  function openDrawer(){
    lastFocus = document.activeElement;
    hideAll();
    drawer.hidden = false; scrim.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('on'); scrim.classList.add('on');
    burger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ dclose.focus(); }, 60);
  }
  function closeDrawer(){
    drawer.classList.remove('on'); scrim.classList.remove('on');
    burger.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
    setTimeout(function(){ drawer.hidden = true; if(!open) scrim.hidden = true; }, 200);
    if(lastFocus) lastFocus.focus();
  }
  burger.addEventListener('click', openDrawer);
  dclose.addEventListener('click', closeDrawer);
  scrim.addEventListener('click', function(){ if(drawer.classList.contains('on')) closeDrawer(); });
  drawer.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ e.stopPropagation(); closeDrawer(); return; }
    if(e.key !== 'Tab') return;
    var f = focusables(); if(!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });

  var accTriggers = Array.prototype.slice.call(root.querySelectorAll('.acctrigger'));
  accTriggers.forEach(function(b){
    b.addEventListener('click', function(){
      var p = root.querySelector('#' + b.getAttribute('aria-controls'));
      var isOpen = b.getAttribute('aria-expanded') === 'true';
      accTriggers.forEach(function(o){
        if(o !== b){ o.setAttribute('aria-expanded','false'); var op = root.querySelector('#' + o.getAttribute('aria-controls')); if(op) op.classList.remove('on'); }
      });
      b.setAttribute('aria-expanded', String(!isOpen));
      p.classList.toggle('on', !isOpen);
      if(!isOpen){ setTimeout(function(){ b.scrollIntoView({ block:'nearest', behavior:'smooth' }); }, 30); }
    });
  });

  mq.addEventListener('change', function(){
    hideAll();
    if(drawer.classList.contains('on')) closeDrawer();
  });

  Array.prototype.forEach.call(root.querySelectorAll('.panel'), function(p){
    Array.prototype.forEach.call(p.querySelectorAll('.col'), function(c, ci){
      c.style.setProperty('--c', ci);
      Array.prototype.forEach.call(c.querySelectorAll('li'), function(li, i){
        li.style.setProperty('--i', i);
      });
    });
  });

  (function(){
    var stack = root.querySelector('.promo-stack');
    if(!stack) return;
    var ps = Array.prototype.slice.call(stack.querySelectorAll('.promo')), k = 0, timer = null;
    if(ps.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function start(){ timer = setInterval(function(){
      ps[k].classList.remove('act'); k = (k + 1) % ps.length; ps[k].classList.add('act');
    }, 6000); }
    function stop(){ clearInterval(timer); }
    stack.addEventListener('mouseenter', stop); stack.addEventListener('mouseleave', start);
    stack.addEventListener('focusin', stop);    stack.addEventListener('focusout', start);
    start();
  })();

  (function(){
    var bar = root.querySelector('.mbar');
    if(!bar || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.lhero, .shopify-section-group-footer-group, body > footer, main ~ footer');
    if(!targets.length) return;
    var seen = [];
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var i = seen.indexOf(e.target);
        if(e.isIntersecting && i === -1) seen.push(e.target);
        if(!e.isIntersecting && i !== -1) seen.splice(i, 1);
      });
      bar.classList.toggle('is-hidden', seen.length > 0);
    }, {rootMargin: '0px 0px -24px 0px'});
    Array.prototype.forEach.call(targets, function(t){ io.observe(t); });
  })();

  (function(){
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var bar = root.querySelector('.mbar');
    var onCartPage = !!(bar && bar.hasAttribute('data-cart-page'));
    var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
    function money(c){
      try { return new Intl.NumberFormat('en-AU',{style:'currency',currency:c.currency || 'AUD'}).format(c.total_price / 100); }
      catch(e){ return '$' + (c.total_price / 100).toFixed(2); }
    }
    function each(sel, fn){ Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
    function paint(c){
      if(!c || typeof c.item_count !== 'number') return;
      var n = c.item_count, word = n === 1 ? 'item' : 'items', total = money(c);
      each('[data-cart-badge]', function(el){ el.textContent = n; el.hidden = n === 0; });
      each('[data-cart-num]', function(el){ el.textContent = n; });
      each('[data-cart-word]', function(el){ el.textContent = word; });
      each('[data-cart-total]', function(el){ el.textContent = total; });
      each('[data-cart-paren]', function(el){ el.textContent = n > 0 ? ' (' + n + ')' : ''; });
      each('[data-cart-card]', function(el){ el.hidden = n === 0; });
      each('[data-cart-link]', function(el){ el.setAttribute('aria-label', 'Cart, ' + n + ' ' + word); });
      if(bar && onCartPage) bar.classList.toggle('mbar--checkout', n > 0);
    }
    var pending = null;
    function refresh(){
      if(!nativeFetch) return;
      clearTimeout(pending);
      pending = setTimeout(function(){
        nativeFetch(rootUrl + 'cart.js', {headers:{Accept:'application/json'}, credentials:'same-origin'})
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(paint)
          .catch(function(){});
      }, 60);
    }
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    if(nativeFetch && !window.__cssCartWatch){
      window.__cssCartWatch = true;
      window.fetch = function(input){
        var req = nativeFetch.apply(window, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if(CART_RE.test(url)) req.then(refresh, function(){});
        } catch(e){}
        return req;
      };
    }
    if(typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate){
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:refresh', refresh);
    window.addEventListener('pageshow', function(e){ if(e.persisted) refresh(); });
  })();

  (function(){
    var chips = root.querySelectorAll('[data-openchip]');
    if(!chips.length) return;
    var HOURS = {Mon:[9.5,18], Tue:[9.5,18], Wed:[9.5,18], Thu:[9.5,21], Fri:[9.5,18], Sat:[9.5,15.5], Sun:null};
    var ORDER = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    function fmt(t){ var hh=Math.floor(t), mm=Math.round((t-hh)*60), ap=hh>=12?'pm':'am', h12=((hh+11)%12)+1;
      return h12 + (mm ? '.' + (mm<10?'0':'') + mm : '') + ap; }
    function update(){
      var parts = new Intl.DateTimeFormat('en-AU',{timeZone:'Australia/Sydney',weekday:'short',hour:'numeric',minute:'numeric',hour12:false}).formatToParts(new Date());
      var get = function(t){ var p = parts.filter(function(x){return x.type===t;})[0]; return p ? p.value : ''; };
      var day = get('weekday').slice(0,3), t = parseInt(get('hour'),10) + parseInt(get('minute'),10)/60;
      var today = HOURS[day], text, open = false;
      if(today && t >= today[0] && t < today[1]){ open = true; text = 'Open now · closes ' + fmt(today[1]); }
      else {
        var di = ORDER.indexOf(day);
        for(var add=0; add<=7; add++){
          var d2 = ORDER[(di+add)%7], hrs = HOURS[d2];
          if(hrs && !(add===0 && t >= hrs[0])){
            text = 'Closed · opens ' + (add===0 ? 'today ' : d2 + ' ') + fmt(hrs[0]); break;
          }
        }
      }
      Array.prototype.forEach.call(chips, function(ch){
        ch.hidden = false;
        ch.classList.toggle('closed', !open);
        ch.innerHTML = '<span class="dot"></span>' + text;
      });
    }
    update(); setInterval(update, 60000);
  })();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function(){
  function init(scope){
    var root = (scope || document).querySelector('[data-srh]');
    if(!root || root.dataset.srhReady) return;
    root.dataset.srhReady = '1';
    var form = root.querySelector('[data-srh-form]');
    if(!form) return;

    /* checkbox filters + sort submit straight away */
    Array.prototype.forEach.call(form.querySelectorAll('[data-srh-auto]'), function(el){
      el.addEventListener('change', function(){
        if(form.requestSubmit){ form.requestSubmit(); } else { form.submit(); }
      });
    });

    /* one facet open at a time on desktop; click outside closes */
    var facets = Array.prototype.slice.call(form.querySelectorAll('[data-srh-facet]'));
    var mqDesk = window.matchMedia('(min-width:750px)');
    facets.forEach(function(d){
      d.addEventListener('toggle', function(){
        if(d.open && mqDesk.matches){ facets.forEach(function(o){ if(o !== d) o.open = false; }); }
      });
    });
    document.addEventListener('click', function(e){
      if(!mqDesk.matches) return;
      facets.forEach(function(d){ if(d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Escape') return;
      facets.forEach(function(d){ if(d.open){ d.open = false; d.querySelector('summary').focus(); } });
    });

    /* mobile filters toggle */
    var tog = form.querySelector('[data-srh-ftoggle]');
    var wrap = form.querySelector('[data-srh-facets]');
    if(tog && wrap){
      tog.addEventListener('click', function(){
        var open = tog.getAttribute('aria-expanded') !== 'true';
        tog.setAttribute('aria-expanded', String(open));
        wrap.classList.toggle('srh__facets--open', open);
      });
    }

    /* drop empty price inputs so the URL stays clean */
    form.addEventListener('submit', function(){
      Array.prototype.forEach.call(form.querySelectorAll('.srh__pin'), function(i){ if(i.value === '') i.disabled = true; });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-wall"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  document.querySelectorAll('.rw-section .rw-wall').forEach(function(wall){
    if(!('IntersectionObserver' in window)) return;
    Array.prototype.forEach.call(wall.querySelectorAll('.rw-card'), function(c,i){ c.style.setProperty('--rw-i', i % 12); });
    wall.classList.add('rw-willstagger');
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ wall.classList.add('rw-inview'); io.disconnect(); } });
    }, {threshold:.05});
    io.observe(wall);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
